export default __webpack_public_path__ + "static/media/circle-check-icon.88c2044b.svg";